.header {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: space-between;
  gap: var(--space-4);
  margin-block-end: var(--space-6);
}
.text {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}
.eyebrow {
  font-size: var(--text-xs);
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--color-accent-ink);
}
.title {
  font-size: var(--text-2xl);
  font-weight: 700;
  line-height: 1.15;
}
.desc {
  color: var(--color-text-muted);
  max-width: 44rem;
}
.actions {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
}
